import React, { memo, useEffect, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { DashboardSection } from "../constants/types";
import { useLocation, useNavigate } from "react-router-dom";

const DashboardSections = ({ userType }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState();

  const handleNavigation = (filterType) => {
    navigate(`/dashboard/${filterType}`);
  };

  useEffect(() => {
    const sectionFromUrl = location.pathname.split("/").pop();
    if (Object.values(DashboardSection).includes(sectionFromUrl)) {
      setSelectedTab(sectionFromUrl);
    }
  }, [location.pathname]);

  return (
    <Box sx={styles.container}>
      <Tabs value={selectedTab} sx={styles.tabs}>
        <Tab
          label="Devices"
          value={DashboardSection.DEVICES}
          onClick={() => handleNavigation(DashboardSection.DEVICES)}
          sx={styles.tab}
        />
        <Tab
          label="Assemblies"
          value={DashboardSection.ASSEMBLIES}
          onClick={() => handleNavigation(DashboardSection.ASSEMBLIES)}
          sx={styles.tab}
        />
        {userType === "MANAGER" && [
          <Tab
            key={DashboardSection.TEST_FIXTURES}
            label="Test Fixture List"
            value={DashboardSection.TEST_FIXTURES}
            onClick={() => handleNavigation(DashboardSection.TEST_FIXTURES)}
            sx={styles.tab}
          />,
          <Tab
            key={DashboardSection.FIRMWARE_UPDATES}
            label="Firmware Updates"
            value={DashboardSection.FIRMWARE_UPDATES}
            sx={styles.tab}
            onClick={() => handleNavigation(DashboardSection.FIRMWARE_UPDATES)}
          />,
          <Tab
            key={DashboardSection.ANALYTICS}
            label="Analytics"
            value={DashboardSection.ANALYTICS}
            sx={styles.tab}
            onClick={() => handleNavigation(DashboardSection.ANALYTICS)}
          />,
        ]}
      </Tabs>
    </Box>
  );
};

export default memo(DashboardSections);

const styles = {
  container: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    mx: 3,
  },
  tabs: {
    backgroundColor: "#F5F5F5",
    borderRadius: "8px",
    minHeight: "48px",
    "& .MuiTabs-indicator": {
      display: "none",
    },
  },
  tab: {
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 400,
    minHeight: "40px",
    px: 3,
    my: 0.5,
    mx: 0.5,
    borderRadius: "6px",
    color: "#717680",
    "&.Mui-selected": {
      backgroundColor: "#E0F2FE",
      color: "#062C41",
      border: "1px solid #B9E6FE",
      fontWeight: 500,
    },
  },
};
